<template lang="pug">
modal.modal-base(
  :name='WINDOW_NAME',
  :width='width',
  :height='height',
  :clickToClose='clickToClose',
  :styles='styles',
  @closed='closed'
)
  .modal-base__content
    slot
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * モーダルウィンドウ表示用ベースタグ
 */
@Component
export default class ModalBase extends Vue {
  // モーダル表示幅(px) - 必須
  @Prop()
  width!: number

  // モーダル表示高さ(px) - 必須
  @Prop()
  height!: number

  // 背景クリック時にモーダルを閉じるか否か(ライブラリオプション)
  //   未指定時はON=閉じる
  @Prop({ default: true })
  clickToClose?: boolean

  // スタイルオプション
  @Prop()
  styles?: { [key: string]: string }

  // UUIDから一意な名前を設定する
  private readonly WINDOW_NAME = this.$uuid.v4()

  // モーダルの消去
  public hide() {
    this.$modal.hide(this.WINDOW_NAME)
  }

  // モーダルの表示
  public show() {
    this.$modal.show(this.WINDOW_NAME)
  }

  // モーダル消去時のイベントを通知
  //   ライブラリ独自イベント、上位コンポーネントへ通知する
  private closed() {
    this.$emit('closed')
  }
}
</script>

<style lang="stylus" scoped>
.modal-base
  &__content
    height 100%
    overflow scroll
</style>
